import { createContext, useContext, useState, ReactNode } from "react";

interface AuthModalContextType {
  isOpen: boolean;
  openAuthModal: (onSuccess?: () => void, mode?: "signin" | "signup") => void;
  closeAuthModal: () => void;
  onSuccessCallback?: () => void;
  mode: "signin" | "signup";
}

const AuthModalContext = createContext<AuthModalContextType | undefined>(undefined);

export function AuthModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [onSuccessCallback, setOnSuccessCallback] = useState<(() => void) | undefined>();
  const [mode, setMode] = useState<"signin" | "signup">("signin");

  const openAuthModal = (callback?: () => void, authMode: "signin" | "signup" = "signin") => {
    setOnSuccessCallback(() => callback);
    setMode(authMode);
    setIsOpen(true);
  };

  const closeAuthModal = () => {
    setIsOpen(false);
    setOnSuccessCallback(undefined);
  };

  return (
    <AuthModalContext.Provider
      value={{ isOpen, openAuthModal, closeAuthModal, onSuccessCallback, mode }}
    >
      {children}
    </AuthModalContext.Provider>
  );
}

export function useAuthModal() {
  const context = useContext(AuthModalContext);
  if (!context) {
    throw new Error("useAuthModal must be used within AuthModalProvider");
  }
  return context;
}
